<template>
  <base-section
    id="organizing-committee"
    space="0"
  >
    <!---
    <base-section-heading title="Organizing Committee">
    </base-section-heading>
    --->
      <v-row>
        <base-avatar-card
          title="General Chair"
          align="left"
          horizontal
        />
      </v-row>
      <v-row>
        <v-col
          v-for="(general, i) in generals"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="general"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
      <v-row>
            <base-avatar-card
            title="Program Co-Chairs"
            align="left"
            horizontal
          >
          </base-avatar-card>
        </v-row>
      <v-row>
        <v-col
          v-for="(program, i) in programs"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="program"
            align="left"
            horizontal
          >
          </base-avatar-card>
        </v-col>
      </v-row>
      <v-row>
            <base-avatar-card
            title="Finance Chair"
            align="left"
            horizontal
          >
          </base-avatar-card>
        </v-row>
      <v-row>
        <v-col
          v-for="(program, i) in finance"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="program"
            align="left"
            horizontal
          >
          </base-avatar-card>
        </v-col>
      </v-row>
      <v-row>
            <base-avatar-card
            title="Publicity Co-Chairs"
            align="left"
            horizontal
          >
          </base-avatar-card>
        </v-row>
      <v-row>
        <v-col
          v-for="(program, i) in publicities"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="program"
            align="left"
            horizontal
          >
          </base-avatar-card>
        </v-col>
      </v-row>
      <v-row>
            <base-avatar-card
            title="Publication Chair"
            align="left"
            horizontal
          >
          </base-avatar-card>
        </v-row>
      <v-row>
        <v-col
          v-for="(program, i) in publications"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="program"
            align="left"
            horizontal
          >
          </base-avatar-card>
        </v-col>
      </v-row>
      <v-row>
        <base-avatar-card
          title="Web Resource"
          align="left"
          horizontal
        />
      </v-row>
      <v-row>
        <v-col
          v-for="(web, i) in webs"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="web"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
      <v-row>
            <base-avatar-card
            title="Local Co-Chairs"
            align="left"
            horizontal
          >
          </base-avatar-card>
        </v-row>
      <v-row>
        <v-col
          v-for="(program, i) in locals"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="program"
            align="left"
            horizontal
          >
          </base-avatar-card>
        </v-col>
      </v-row>
  </base-section>
</template>

<script>
  export default {
    name: 'OrganizingCommittee',

    data: () => ({
      isMobile: false,
      generals: [
        {
          title: 'Alberto Bosio',
          src: require('@/images/committees/albertobosio.jpg'),
          text: 'INL, FR',
        },
      ],
      programs: [
        {
          title: 'Paolo Bernardi',
          src: require('@/images/committees/paolobernardi.jpg'),
          text: 'Politecnico di Torino, IT',
        },
        {
          title: 'Marcello Traiola',
          src: require('@/images/committees/marcellotraiola.jpg'),
          text: 'INRIA, FR',
        },
      ],
      finance: [
        {
          title: 'Bastien Deveautour',
          src: require('@/images/committees/bastien.jpg'),
          text: 'INL, FR',
        },
      ],
      locals: [
        {
          title: 'Nicolo\' Bellarmino',
          src: require('@/images/committees/nicolobellarmino.jpg'),
          text: 'Politecnico di Torino, IT',
        },
        {
          title: 'Salvatore Pappalardo',
          src: require('@/images/committees/salvatore.jpg'),
          text: 'INL, FR',
        },
        {
          title: 'Leonardo Alexandrino',
          src: require('@/images/committees/alexandrino.jpg'),
          text: 'INL, FR',
        },
      ],
      publicities: [
        {
          title: 'Angeliki Kritikakou',
          src: require('@/images/committees/kritikakou.jpg'),
          text: 'IRISA, FR',
        },
        {
          title: 'Petr Fiser',
          src: require('@/images/committees/petrfiser.jpg'),
          text: 'CTU in Prague, CZ',
        },
      ],
      publications: [
        {
          title: 'Vojtech Mrazek',
          src: require('@/images/committees/mrazek.jpg'),
          text: 'VUT Brno, CZ',
        },
      ],
      webs: [
        {
          title: 'Giusy Iaria',
          src: require('@/images/committees/giusyiaria_2.jpg'),
          text: 'Politecnico di Torino, IT',
        },
        {
          title: 'Nicolo\' Bellarmino',
          src: require('@/images/committees/nicolobellarmino.jpg'),
          text: 'Politecnico di Torino, IT',
        },
      ],
      mounted () {
        this.isMobile = (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
      },
      methods: {
        isMobileDevice () {
          return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
        },
      },
    }),
  }
</script>
